import { Component } from '@angular/core';
import {ConfigureBaseComponent} from '../../configure-base/configure-base.component';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ConfigureWidgetTotalsComponent} from '../configure-widget-totals.component';
import {WidgetUtils} from '../../widget-utils';
import {dialogOpen} from '../../../../../../shared/store/dialog/dialog.actions';

@Component({
  selector: 'app-configure-widget-totals-total',
  templateUrl: './configure-widget-totals-total.component.html',
  styleUrls: ['./configure-widget-totals-total.component.scss']
})
export class ConfigureWidgetTotalsTotalComponent extends ConfigureBaseComponent {

  public readonly form: FormGroup = new FormGroup({
    filters: new FormControl({}),
    name: new FormControl(null, [Validators.required]),
    metric: new FormControl(null, [Validators.required])
  });

  public onSubmit(): void {
    if (this.data.config) {
      this.data.total.dimensions = WidgetUtils.getFilterDimensions(this.form.get('filters').value, this.dimensions);
      this.data.total.metric = this.form.get('metric').value;
      this.data.total.filters = this.form.get('filters').value;
      this.data.total.name = this.form.get('name').value;
      this.data.total.params = {
        dimensions: [],
        metrics: [this.form.get('metric').value]
      };
    } else {
      this.data.totals.push({
        name: this.form.get('name').value,
        dimensions: WidgetUtils.getFilterDimensions(this.form.get('filters').value, this.dimensions),
        metric: this.form.get('metric').value,
        filters: this.form.get('filters').value,
        params: {
          dimensions: [],
          metrics: [this.form.get('metric').value]
        }
      });
    }

    this.onClose();
  }

  public onClose(): void {
    this._store.dispatch(dialogOpen({
      component: ConfigureWidgetTotalsComponent,
      config: {
        width: '750px',
        height: 'auto'
      },
      data: {
        mode: this.data.mode,
        widget: this.data.widget,
        dashboard: this.data.dashboard,
        totals: this.data.totals,
        enableCharts: this.data.enableCharts,
        form: this.data.form
      }
    }));
  }

}
